import React from "react";

export default function Hero() {
  return (
    <section className="hero">
      <div className="container hero-container">
        <div className="hero-text">
          <span className="badge">Certified English to Arabic Translation in the UK</span>

          <h1>
            Professional Certified Translation for Legal, Official and Business Documents
          </h1>

          <p>
            Clear, accurate and professionally prepared English to Arabic
            translations for individuals, law firms, businesses and official
            submissions. Designed for clients who need reliability, trust and
            professional standards.
          </p>

          <div className="hero-buttons">
            <a href="/#quote" className="btn btn-primary">
              Request a Quote
            </a>
            <a href="#services" className="btn btn-secondary">
              View Services
            </a>
          </div>

          <div className="hero-trust-row">
            <span>✔ Human Translation</span>
            <span>✔ Confidential Handling</span>
            <span>✔ Professional Quality</span>
          </div>
        </div>

        <div className="hero-card">
          <div className="info-card">
            <div className="credential-badge">Trusted Professional Service</div>
            <h3>Reliable Translation Support</h3>
            <p>
              Suitable for legal, administrative, academic and business
              documents requiring clarity, precision and a professional finish.
            </p>

            <div className="mini-stats">
              <div className="mini-stat">
                <strong>EN → AR</strong>
                <span>Main Language Pair</span>
              </div>

              <div className="mini-stat">
                <strong>Legal</strong>
                <span>Specialised Documents</span>
              </div>

              <div className="mini-stat">
                <strong>UK</strong>
                <span>Professional Market Focus</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}